<div class="trigger-gc-section-container">
    <div class="trigger-gc-section-title">Trigger garbage collector</div>
    <div> <app-action-button-with-embedded-spinner class="process-actions-button small-action-button"
            [disabled]="!canStart" [actionObservable]="triggerGarbageCollector.bind(this)" [icon]="'handyman'"
            [hint]="'Trigger garbage collector'">
        </app-action-button-with-embedded-spinner></div>
</div>